// Electus Distribution support contact details. Single source of truth,
// surfaced by the SignInDrawer's "Need Help?" footer (EWM-267) and the mobile
// navigation drawer's contact section (EWM-295).
//
// Confirmed in the May 27 mockup and the EWM-267 ticket details — same numbers
// for AU and NZ stores today. Per-dealer / per-organisation contact details are
// an open question on EWM-295 and would be a future backend extension; until
// then these globals apply to every locale.
export const SUPPORT_PHONE_DISPLAY = '1300 738 555';
export const SUPPORT_PHONE_TEL = '1300738555';
export const SUPPORT_EMAIL = 'support@electus.com.au';
